import React from 'react';
import { Loader2 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface AIProcessingStatusProps {
  isProcessing: boolean;
}

export function AIProcessingStatus({ isProcessing }: AIProcessingStatusProps) {
  if (!isProcessing) {
    return null;
  }

  return (
    <Badge 
      variant="secondary" 
      className="animate-pulse bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200 border-blue-200 dark:border-blue-700"
    >
      <Loader2 className="mr-1 h-3 w-3 animate-spin" />
      AI Processing...
    </Badge>
  );
}